module.exports = __webpack_public_path__ + "2b7552fdadb6264f268327d01907855d.png";